import { useState, useEffect } from "react";
import { useAuth } from "../Management/AuthContext";
import axios from "axios";
import { Divider } from "@mui/material";
import clock_3 from "../../assets/images/NewEvent/clock_3.svg";
import user_status from "../../assets/images/NewEvent/user_status.svg";
import list from "../../assets/images/NewEvent/list.svg";
import { Button, Label } from "flowbite-react";
import LinkInputModal from "../tiptap-editor/extensions/modal";

function extractFirstImageAndText(htmlContent) {
  // Tìm thẻ <img> đầu tiên
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1]; // Lấy src của thẻ <img> đầu tiên
  }

  // Xóa thẻ <img> đầu tiên khỏi nội dung HTML
  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");

  return { text: textWithoutFirstImage, firstImage };
}

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

function renderNewsRow(
  categories,
  newsData,
  onEdit,
  onUpdateStatus,
  showConfirm,
  user
) {
  let { text, firstImage } = extractFirstImageAndText(newsData.shortContent);
  return (
    <div className=" w-full gap-3 hover:border hover:border-blue-500 rounded-[8px] border border-solid border-gray-300 shadow-custom-light ">
      <div className="w-full flex flex-col gap-3">
        <div>
          <img
            src={firstImage}
            className="w-full h-44 object-cover rounded-[8px]"
          />
        </div>
        <div className="w-full px-[24px] py-[16px] flex flex-col gap-3">
          <div>
            <p className="text-[16px] font-semibold text-[#1F1F1F] hover:text-[#053CC8] cursor-pointer">
              {newsData.title}
            </p>
          </div>
          <div className="flex items-center justify-between w-full md:flex-col lg:flex-row md:gap-1 md:items-center md:justify-center">
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={user_status} alt="mjm" />
              </div>
              <p>{newsData.author}</p>
            </div>
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={clock_3} alt="njj" />
              </div>
              <p>{new Date(newsData.publishDate).toLocaleDateString()}</p>
            </div>
          </div>
          <div>
            <Divider />
          </div>
          <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
            <div>
              <img src={list} alt="brt" />
            </div>
            <div>
              <p>{getCategoryName(categories, newsData.categories)}</p>
            </div>
          </div>
          <div className="h-32 overflow-auto overflow-x-hidden">
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
          <div className="w-full flex items-center justify-center gap-2">
            <Button
              className="bg-green-400 hover:bg-green-500"
              onClick={() => onEdit(newsData.id)}
            >
              Sửa
            </Button>
            <Button
              className="bg-red-400 hover:bg-red-500"
              onClick={() => {
                showConfirm(newsData.id);
              }}
            >
              Xóa
            </Button>
            <div className="w-full border border-gray-300 rounded-lg">
              {" "}
              <select
                name="position"
                className="flex-1 bg-transparent outline-none border-none placeholder-gray-500 w-full"
                value={newsData.status}
                onChange={(e) => {
                  handleUpdateStatus(
                    newsData.id,
                    e.target.value,
                    user,
                    onUpdateStatus
                  );
                }}
              >
                {" "}
                <option value="">Trạng thái bài viết</option>{" "}
                <option value="0">Nháp</option>{" "}
                <option value="1">Chờ duyệt</option>{" "}
                <option value="2">Xuất bản</option>{" "}
              </select>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const handleUpdateStatus = async (id, status, user, onUpdateStatus) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/publish",
    { id, status }
  );
  if (response.status == 200) {
    onUpdateStatus(id, status);
    alert("Cập nhật thành công");
  }
};

export default function CaseStudyDetail({
  categories,
  news,
  onEditNews,
  onUpdateNews,
}) {
  const { user } = useAuth();
  const [confirmDeleteId, setConfirmDeleteId] = useState(0);
  const [caseStudies, setCaseStudies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = 6;
  const totalPages = caseStudies ? caseStudies.length / eventsPerPage : 1;
  const [activeTab1, setActiveTab1] = useState("Tin mới nhất");
  useEffect(() => {
    setCaseStudies(news);
  }, [news]);

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    let pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`px-3 py-1 rounded-lg ${
              i === currentPage
                ? "bg-blue-100 text-blue-500 font-semibold"
                : "text-gray-700"
            }`}
          >
            {i}
          </button>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pageNumbers.push(
          <span key={i} className="px-2 text-gray-500">
            ...
          </span>
        );
      }
    }
    return pageNumbers;
  };

  const showConfirm = (id) => {
    setConfirmDeleteId(id);
  };
  const onUpdateStatus = (id, status) => {
    let updateList = [];
    if (status === -1) {
      updateList = caseStudies.filter((c) => c.id != id);
    } else {
      updateList = caseStudies.map((c) => {
        if (c.id == id) {
          c.status = status;
        }
        return c;
      });
    }
    onUpdateNews(updateList);
  };
  const startIndex = (currentPage - 1) * eventsPerPage;
  const endIndex = startIndex + eventsPerPage;
  const currentEvents = caseStudies
    ? caseStudies.slice(startIndex, endIndex)
    : [];
  const updatedTotalPages = Math.ceil(
    caseStudies ? caseStudies.length / eventsPerPage : 0
  );

  const renderContent = () => {
    switch (activeTab1) {
      case "Tin mới nhất":
        return (
          <div className="grid grid-cols-3 gap-5">
            {currentEvents &&
              currentEvents.map((newData, index) => (
                <div key={newData.id}>
                  {renderNewsRow(
                    categories,
                    newData,
                    onEditNews,
                    onUpdateStatus,
                    showConfirm,
                    user
                  )}
                </div>
              ))}
            <LinkInputModal
              title="Xác nhận xóa"
              openModal={confirmDeleteId > 0}
              onClose={() => {
                setConfirmDeleteId(0);
              }}
            >
              <div className="space-y-6">
                <div className="mb-2 block">
                  <Label value="Bạn có chắc chắn muôn xóa?" />
                </div>
                <div className="w-full">
                  <Button
                    onClick={() => {
                      handleUpdateStatus(
                        confirmDeleteId,
                        -1,
                        user,
                        onUpdateStatus
                      );
                      setConfirmDeleteId(0);
                    }}
                  >
                    Ok
                  </Button>
                </div>
              </div>
            </LinkInputModal>
          </div>
        );
    }
  };

  return (
    <div className="w-full p-3">
      <div className="mt-4 p-4">{renderContent()}</div>

      <div className="flex items-center justify-between space-x-4 mt-4">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50"
        >
          ← Trước
        </button>
        <div className="flex items-center space-x-1">{renderPageNumbers()}</div>
        <button
          onClick={handleNext}
          disabled={currentPage === updatedTotalPages}
          className="px-4 py-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50"
        >
          Sau →
        </button>
      </div>
    </div>
  );
}
